import { IDisplayOptions, IGeneralInformation } from '@modeso/types__aumico-lib-annualreport-be';

// Answers the comparison-period questions and reads a stored date as a Date.
export class PreviousPeriodHelper {
    // True when the report has no comparison period at all.
    static hasNoPreviousPeriod(generalInformation: IGeneralInformation | undefined): boolean {
        return generalInformation?.noPreviousData === true || this.isMissing(generalInformation?.balancePreviousYearDate);
    }

    // True when this print shows no comparison column.
    static hidesPreviousPeriod(
        generalInformation: IGeneralInformation | undefined,
        displayOptions: IDisplayOptions | undefined,
    ): boolean {
        return this.hasNoPreviousPeriod(generalInformation) || displayOptions?.hidePreviousYear === true;
    }

    // A stored date as a Date, or undefined when none was stored.
    static toDate(date: string | null | undefined): Date | undefined {
        return this.isMissing(date) ? undefined : new Date(date);
    }

    // True when no date was stored. An empty string counts as absent.
    private static isMissing(date: string | null | undefined): boolean {
        return date == null || date === '';
    }
}
